import React from "react"
import { Card, Masonry, Tag } from 'antd';
import { read } from "node:fs";

type MasonryItemType = {
    key: string;
    data: number;
    children?: React.ReactNode;
};


const generateRandomNumbers = (n: number) => {
    const numbers = [];
    for (let i = 0; i < n; i++) {
        const randomNumber = Math.floor(Math.random() * (150 - 50 + 1)) + 50;
        numbers.push(randomNumber);
    }
    return numbers;
}

export const Articles = () => {
    const data = [
        {
            description: 'Honey bees are social insects that live in colonies.',
            content: `Honey bees are social insects that live in `,
            bookId: 18,
            testId: 1,
            readingId: 2,
            articleId: "18-1-1",
            title: 'eat honey',
        },
        {
            description: 'The Late Bronze Age collapse was a Honey transition period in the Near East and Eastern Mediterranean.',
            content: `The Late Bronze Age collapse was a Honey transition period in the Near East and Eastern Mediterranean. Honey bees are social insects that live in `,
            bookId: 18,
            testId: 1,
            readingId: 3,
            articleId: "18-1-2",
            title: '18-1-2',
        }
    ]



    const heights = generateRandomNumbers(data.length).map(
        (height, index) => {
            const item: MasonryItemType = {
                key: `item-${index}`,
                data: height,
            };

            if (index !== 4) {
                item.children = (
                    <Card
                        size="small"
                        cover={
                            <img
                                alt="food"
                                src="https://images.unsplash.com/photo-1491961865842-98f7befd1a60?w=523&auto=format"
                            />
                        }
                    >
                        <Card.Meta title={data[index].title} description={data[index].description} />
                        <div style={{display:'flex', flexDirection:'row', gap:'4px'}}>
                            <Tag style={{ margin: "8px 0 0" }} key={data[index].bookId} color="orange" variant="outlined" onClick={(e)=>{
                                console.log(data[index].bookId)
                            }}>
                                剑桥 {data[index].bookId}
                            </Tag><Tag style={{ margin: "8px 0 0" }} key={data[index].testId} color="orange" variant="outlined">
                                Test {data[index].testId}
                            </Tag>
                            <Tag style={{ margin: "8px 0 0" }} key={data[index].readingId} color="orange" variant="outlined">
                                Reading {data[index].readingId}
                            </Tag>
                        </div>

                    </Card>
                );
            }

            return item;
        },
    );
    return <div style={{ padding: 20 }}>
        <h1>Articles</h1>
        <Masonry
            columns={4}
            gutter={16}
            items={heights}
            itemRender={({ data, index }) => (
                <Card size="small" style={{ height: data }}>
                    {index + 1}
                </Card>
            )}
        />
    </div>
}